import LazyLoad from './../library/LazyLoad';

export default class Insights {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Insights;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		window.site.animateInsights = function() {
			const lazyLoad = new LazyLoad();
			lazyLoad.fadeInStaggerElement('.js-insight-results, .js-insight-pagination');
		};

		if (window.location.search) {
			let search = window.location.search.substring(1),
				searchObj = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

			if (searchObj.category) {
				self.loadCategory(searchObj.category, true);
				self.loadSubCategory(searchObj.subcategory, true);
				$('.js-insights-form').request();
			}
		}

		$(document).on('click', '.js-insights-pagination', function(e) {
			e.preventDefault();
			self.loadPage($(this).data('page'));
		});

		$(document).on('click', '.js-insights-category', function(e) {
			e.preventDefault();
			self.loadCategory($(this).data('category'), false);
		});

		$(document).on('change', '.js-insights-sub-category', function() {
			self.loadSubCategory($(this).val(), false);
		});

		$(document).on('submit', '.js-insights-search', function(e) {
			e.preventDefault();
			self.loadByKeywords($(this).find('input[name="query"]').val());
		});
	}

	loadPage(page) {
		const self = this,
			$form = $('.js-insights-form');

		$form.find('input[name="page"]').val(page);
		$form.request();
	}

	loadCategory(category, preventSubmit) {
		const self = this,
			$form = $('.js-insights-form'),
			$categoryField = $form.find('input[name="categoryId"]'),
			currentCategory = $categoryField.val();

		$('.js-insights-category').parent('li').removeClass('is-active');

		/*if (category == currentCategory) {
			category = '';
		} else {
			$('.js-insights-category[data-category="' + category + '"]').parent('li').addClass('is-active');
		}*/

		$('.js-insights-category[data-category="' + category + '"]').parent('li').addClass('is-active');


		$('.js-insight-results').empty();
		$categoryField.val(category);
		$form.find('input[name="page"]').val(1);

		if (preventSubmit == false) {
			$form.request();
		}
	}

	loadSubCategory(subCategory, preventSubmit) {
		const self = this,
			$form = $('.js-insights-form'),
			subCats = [];

		$('.js-insights-sub-category:checked').each(function() {
			subCats.push($(this).val());
		});

		$form.find('input[name="subCategories[]"]').remove();

		$.each(subCats, function(key, cat) {
			$form.append('<input type="hidden" name="subCategories[]" value="' + cat + '">');
		});

		$('.js-insight-results').empty();
		$form.find('input[name="page"]').val(1);

		if (preventSubmit == false) {
			$form.request();
		}
	}

	loadByKeywords(query) {
		const self = this,
			$form = $('.js-insights-form');

		$form.find('input[name="query"]').val(query);

		// unset any categories and sub categories
		self.loadCategory('all', false);
		$('.js-insights-sub-category').prop('checked', false);
		$form.find('input[name="subCategories[]"]').remove();
	}
}
